export const state = {
  notification: {
    icon: '',
    id: 0,
    message: '',
    timeout: 10000,
    title: '',
    type: 'info',
    data: undefined
  },
  notifications: [],
  notificationsTotal: 0,
};
